import React, { useEffect, useState } from "react";
import { db } from "../firebase.js";
import { ref, onValue } from "firebase/database";
import { Box, CssBaseline } from "@mui/material";
import { dbPath } from "../configs/dbConfig.js";
import Breadcrumbs from "../components/Breadcrumbs.js";
import MenuHeader from "../components/MenuHeader.js";
import SidebarDrawer from "../components/SidebarDrawer.js";
import MenuSection from "../components/MenuSection.js";

export default function CartridgeMenu() {
  const [cartridges, setCartridges] = useState([]);

  useEffect(() => {
    onValue(ref(db, `/${dbPath}/Cartridges/`), (snapshot) => {
      setCartridges([]);
      const data = snapshot.val();
      if (data !== null) {
        Object.values(data).map((cartridge) => {
          return setCartridges((oldArray) => [...oldArray, cartridge]);
        });
      }
    });
  }, []);

  const brandItemCount = {};
  cartridges
    .filter((cartridge) => cartridge.active)
    .forEach(({ cartridge }) => {
      if (brandItemCount[cartridge]) {
        brandItemCount[cartridge] += 1;
      } else {
        brandItemCount[cartridge] = 1;
      }
    });

  const sortedBrands = Object.keys(brandItemCount).sort((a, b) => {
    return brandItemCount[b] - brandItemCount[a];
  });

  const popularBrands = sortedBrands.slice(0, 5);

  return (
    <Box className="sidebar-container" sx={{ display: "flex" }}>
      <CssBaseline />
      {/* Header + Sidebar */}
      <MenuHeader menuTitle={"Cartridge Menu"} />
      <SidebarDrawer
        toolbarTitle={"Good Guy Vapes - Lancaster"}
        link={popularBrands}
      />
      <Box className="homepage" component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Breadcrumbs crumb={"Cartridges"} />
        {/* Inventory */}
        <MenuSection data={cartridges} itemType="cartridge" />
      </Box>
    </Box>
  );
}
